<template>
  <div class="breadcrumbs">
    <h3 class="breadcrumbs__step-desc">{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  data () {
    return {
      titleList: {
        checkout: 'Preencha os dados do pagamento',
        funcionario: 'Confirmação de dados cadastrais'
      }
    }
  },
  computed: {
    title () {
      return this.titleList[process.env.VUE_APP_JOURNEY_NAME]
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~@/assets/style/_variables.scss';

  .breadcrumbs {
    margin: 0 16px ;

    @media screen and (min-width: 768px) {
      margin: 0 0 24px;
    }

    &__back-btn {
      align-items: center;
      background-color: #f6fbfd;
      color: #636D7A;
      display: flex;
      font-family: $oscine-font-family;
      font-size: 16px;
      font-weight: 700;
      margin-bottom: 16px;

      @media (max-width: 767px) {
        margin-bottom: 32px;
      }
    }

    &__step-icon {
      margin-right: 16px;
    }

    &__step-num {
      color: #76767A;
      font-size: 14px;
      font-family: $rubik-font-family;
      font-weight: normal;
      line-height: 24px;
      margin: 0px 0 3px 0;
    }

    &__step-desc {
      @media screen and (max-width: 767px) {
        display: none;
      }

      @media screen and (min-width: 768px) {
        color: #3F4956;
        font-family: $oscine-font-family;
        font-size: 32px;
        font-weight: 700;
        line-height: 25px;
        padding: 0;
      }
    }
  }
</style>
